module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "mobileEmailFooterDarkMode.0022eb23.jpg";